import React, { useState } from 'react';
import {
  Container,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
  Alert
} from '@mui/material';

function SessionStart({ onStartSession }) {
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username.trim()) {
      setError('Please enter your name');
      return;
    }

    try {
      setLoading(true);
      setError('');

      await onStartSession({
        username: username.trim(),
        mode: 'assessment'
      });
    } catch (err) {
      setError('Failed to start session. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" style={{ marginTop: '4rem' }}>
      <Card elevation={3}>
        <CardContent style={{ padding: '2rem' }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            KBAT Math App
          </Typography>
          
          <Typography variant="body1" paragraph align="center" color="textSecondary">
            Adaptive Learning for Malaysian Standard 4 Mathematics
          </Typography>

          <Box component="form" onSubmit={handleSubmit} marginTop="2rem">
            <TextField
              fullWidth
              label="Your Name"
              variant="outlined"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              margin="normal"
              required
              disabled={loading}
              helperText="Enter your name to start"
              autoFocus
            />

            {error && (
              <Alert severity="error" style={{ marginBottom: '1rem' }}>
                {error}
              </Alert>
            )}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              disabled={loading}
              style={{ marginTop: '1rem', padding: '0.75rem' }}
            >
              {loading ? 'Starting Assessment...' : 'Start Timed Assessment'}
            </Button>
          </Box>

          <Box marginTop="2rem" padding="1rem" bgcolor="#f5f5f5" borderRadius="8px">
            <Typography variant="h6" gutterBottom>
              How it works:
            </Typography>
            <Typography variant="body2" paragraph>
              1. Answer questions that require thinking, not just calculation
            </Typography>
            <Typography variant="body2" paragraph>
              2. If you get it wrong, tell us how you thought about it
            </Typography>
            <Typography variant="body2" paragraph>
              3. The app adapts to your learning style and helps you improve
            </Typography>
            <Typography variant="body2">
              4. Progress through chapters as you master each topic
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}

export default SessionStart;